import request from "utils/request";
const state = {
  schoolData: ""
};

const actions = {
  async setSchoolData({ commit }) {
    let url = window.location.href;
    console.log("dynamicUrl:" + url);
    const myUrl = url.split("/portal")[0];
    //获取路由中产业学院的参数 例如 feature-tdgc
    const params = { url: myUrl }; //{url:urlArr[0]}
    const res = await request({
      url: "/Business/GetSchoolData",
      method: "get",
      params: params
    });
    commit("SET_VALUE", {
      key: "schoolData",
      value: res.Result
    });
    // sessionStorage.setItem("schoolData", JSON.stringify(res.Result));
    return res;
  }
};

const mutations = {
  SET_VALUE(state, params) {
    state[params.key] = params.value;
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
